<div class="page-layout" [class.center]="center">
  <div class="page-inner">
    <ng-content />
  </div>
</div>
